import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vModelText as _vModelText, createTextVNode as _createTextVNode, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a7317de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-terminate-practice-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Law Practice ID:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Law Practice name:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Branch Address", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_10 = { class: "row ma-0" }
const _hoisted_11 = { class: "col-6 ma-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Appointed Date:", -1))
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = { class: "col-6 ma-0" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Termination Date:", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "checkbox-button" }
const _hoisted_18 = {
  class: "checkbox-elmt",
  style: {"border":"none"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
], -1))
const _hoisted_20 = { class: "checkbox-text" }
const _hoisted_21 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Reason for termination:", -1))
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "validation-msg error"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }, null, -1))
const _hoisted_27 = { class: "controls mt-4" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      halfScreen: "true",
      onClose: _cache[4] || (_cache[4] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.inEditMode ? 'Edit' : 'View') + " Practice", 1)
        ])
      ]),
      body: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
              key: 0,
              class: "loading-indicator",
              showLoadingText: false
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_4,
              _createElementVNode("div", null, _toDisplayString(_ctx.practice?.firmId), 1),
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", null, _toDisplayString(_ctx.practice?.practiceName), 1),
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", null, _toDisplayString(_ctx.practice?.address), 1),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$formatDate(_ctx.practice?.effectiveStartDate)), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  (_ctx.inEditMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["checkbox", _ctx.submitButtonPressed && !_ctx.terminated ? 'error' :''])
                        }, [
                          _createElementVNode("label", _hoisted_17, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.terminated) = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.terminated]
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$formatDate(new Date())) + " (Today)", 1)
                            ])
                          ])
                        ], 2)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$formatDate(_ctx.practice?.effectiveEndDate)), 1))
                ])
              ]),
              _hoisted_22,
              _hoisted_23,
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.practice.terminationReason) = $event)),
                class: _normalizeClass(_ctx.submitButtonPressed && _ctx.practice.terminationReason == '' ? 'error' :''),
                style: {"border":"1px solid #aaa","height":"130px","resize":"vertical","width":"100%"},
                maxlength: 5000,
                placeholder: "Enter reason",
                disabled: !_ctx.inEditMode
              }, null, 10, _hoisted_24), [
                [_vModelText, _ctx.practice.terminationReason]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["footnote", [_ctx.practice.terminationReason?.length === 5000 ? 'full' : '']])
              }, _toDisplayString(_ctx.practice.terminationReason?.length || 0) + "/5000 characters ", 3),
              (_ctx.practice.terminationReason == '' & _ctx.submitButtonPressed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _createTextVNode(" Required field. ")
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          (_ctx.submitting)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-outline",
            disabled: _ctx.submitting,
            onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, " Cancel ", 8, _hoisted_28),
          (_ctx.inEditMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-primary ml-2",
                disabled: _ctx.submitting,
                onClick: _cache[3] || (_cache[3] = _withModifiers($event => (_ctx.save()), ["prevent","stop"]))
              }, " Save ", 8, _hoisted_29))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}